<template>
  <div>
    <b-card
      no-body
      class="mt-3 p-4"
      header="Form Attributes"
    >
      <div v-if="!isLoading">
        <b-table-simple v-if="form1.formsSettings && form1.formsSettings.data">
          <b-thead>
            <b-tr>
              <b-th>Key</b-th>
              <b-th>Value</b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>

          <b-tbody>
            <b-tr
              v-for="(data, index) in form1.formsSettings.data"
              :key="index"
            >
              <b-td>
                <b-form-input v-model="data.key"></b-form-input>
              </b-td>
              <b-td>
                <b-form-input v-model="data.value"></b-form-input>
              </b-td>
              <b-td>
                <b-btn
                  size="sm"
                  variant="outline-danger"
                  @click="onDeleteData(index)"
                >
                  <i class="fa fa-trash"></i>
                </b-btn>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-btn
          class="float-left"
          size="sm"
          variant="outline-info"
          @click="addDataAttribute"
        >
          <i class="fa fa-plus"></i>
        </b-btn>
      </div>
    </b-card>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Helper } from "../helpers";
import { HTTP } from "../utils/HTTP";
import moment from "moment";
export default {
  name: "FormSettingsContainer",
  data () {
    return {
      isLoading: true,
      isLoadingLocal: false
    }
  },
  computed: {
    ...mapState( ['form1'] )
  },
  mounted () {
    this.assignData();
  },
  methods: {
    async onSaveJsonData () {
      let formId = localStorage.getItem( "activeFormId" );
      if ( formId && this.form1.formId ) {
        this.isLoadingLocal = true;
        let payload = this.form1;

        let token = "Bearer " + localStorage.getItem( "accessToken" );
        try {
          let result = await HTTP( "put", "v1/form/edit/" + formId, payload, {
            Authorization: token,
          } );
          this.isLoadingLocal = false;
          if ( result && result.data ) {
            localStorage.setItem( "activeFormSchema", JSON.stringify( this.form ) );
            let toLocal = moment.utc( result.data.updated_at.date ).local().format();

            let toFrom = moment( toLocal ).calendar();
            this.lastUpdatedTime = toFrom;
            Helper.makeToast( this.$bvToast, "success", "Form Save Success" );
          }
        } catch ( error ) {
          this.isLoadingLocal = false;
          Helper.makeToast( this.$bvToast, "danger", "Form not save please try again" );
        } finally {
          this.isLoadingLocal = false;
        }
      }
    },
    assignData () {
      this.isLoading = true;
      if ( this.form1.formsSettings ) {
        this.isLoading = false;
        return;
      } else {
        let formsSettings = {
          data: [
            { key: null, value: null }
          ]
        };
        Object.assign( this.form1, { formsSettings } );
        this.isLoading = false;
        // this.onSaveJsonData();
      }
    },

    addDataAttribute () {
      this.isLoading = true;
      this.form1.formsSettings.data.push( { key: null, value: null } );
      this.isLoading = false;
      // this.onSaveJsonData();
    },

    onDeleteData ( index ) {
      this.isLoading = true;
      this.form1.formsSettings.data.splice( index, 1 );
      this.isLoading = false;
      // this.onSaveJsonData();
    },
  }
}
</script>